<template>
  <el-dialog fullscreen :visible="isShow" :modal="false" :show-close="false" custom-class="dialog-form">
    <div slot="title" class="dialog-title-container">
      <span class="title-label"><i class="el-icon-document"></i> 半成品入库表单</span>
      <i class="el-icon-error" @click="close"></i>
    </div>
    <el-row class="form-top-btns">
      <template v-if="role_name === '超级权限' || role_name === '软件管理'">
        <el-button v-if="!formStatus && formData.id !== '0'" type="primary" size="mini" plain round icon="em-icon-edit" @click="formStatus = !formStatus"> 编辑</el-button>
        <el-button v-if="formStatus && formData.id !== '0'" type="info" size="mini" plain round icon="em-icon-edit" @click="formStatus = !formStatus"> 取消编辑</el-button>
        <el-button v-if="formStatus" type="primary" size="mini" plain round icon="em-icon-save" @click="handerSave"> 提交保存</el-button>
      </template>
      <el-button type="danger" size="mini" plain round icon="el-icon-close" @click="close">关闭</el-button>
    </el-row>
    <div class="form-container">
      <el-form ref="form" :model="formData" size="mini" label-width="80px">
        <div class="form-main">
          <el-row>
            <el-col :span="6">
              <el-form-item label="入库日期" required>
                 <el-date-picker v-if="formStatus" value-format="yyyy-MM-dd HH:mm" type="datetime" size="mini" placeholder="选择日期" clearable v-model="formData.date"></el-date-picker>
                 <span v-else>{{formData.date}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="入库单号">
                <el-input v-if="formStatus" placeholder="入库单号" v-model="formData.halfproduct_no" disabled></el-input>
                <span v-else>{{formData.halfproduct_no}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="备注">
                <el-input v-if="formStatus" placeholder="备注" v-model="formData.remark"></el-input>
                <span v-else>{{formData.remark}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="扫码区域">
                <el-input :disabled="inputdisabled" ref="input" class="areaStyle" v-if="formStatus" @change="areaChange(formData.area)" placeholder="扫码区域" v-model="formData.area"></el-input>
                <span v-else>{{formData.area}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="detail-header">
            <div class="detail-title"><i class="em-icon-th-list"></i> 半成品入库明细</div>
        </div>
        <div class="el-table-container form-details" style="top: 66px;">
          <div style="height: 100%;">
            <el-table :data="formData.details" size="mini" height="100%" style="width: 100%; border:1px solid #d1d1d1;" border header-row-class-name="list-header-row" :row-class-name="tableRowClassName">
              <el-table-column label="序号" type="index" width="47" align="center"></el-table-column>
              <el-table-column label="样本册名称" prop="product_name" width="100" align="center"></el-table-column>
              <el-table-column label="部品名称" prop="base_material_name" width="100" align="center"></el-table-column>
              <el-table-column label="台数" prop="table_number" width="80" align="center"></el-table-column>
              <el-table-column label="页码" prop="page" width="80" align="center"></el-table-column>
              <el-table-column label="送货数量" prop="delivery_number" width="80" align="center"></el-table-column>
              <el-table-column label="入库数量" width="80" align="center">
                <template v-slot:default="scope">
                  <el-input size="mini" v-if="formStatus" placeholder="数量" class="txtC" v-model="scope.row.number" @change="numberChange(scope.row)"></el-input>
                  <span v-else>{{scope.row.number}}</span>
                </template>
              </el-table-column>
              <el-table-column label="库位" width="140" align="center">
                <template v-slot:default="scope">
                  <el-select v-if="formStatus" clearable filterable size="mini" v-model="scope.row.position" placeholder="请选择" @change="positionChange(scope.row)">
                    <el-option v-for="item in positionArr" :key="item.id"  :label="item.name" :value="item.id"></el-option>
                  </el-select>
                  <span v-else>{{scope.row.position_value}}</span>
                </template>
              </el-table-column>
              <el-table-column label="异常原因" width="200" align="center">
                <template v-slot:default="scope">
                  <el-input size="mini" v-if="scope.row.delivery_number !== scope.row.number && formStatus" placeholder="异常原因" v-model="scope.row.exception_result"></el-input>
                  <span v-else>{{scope.row.exception_result}}</span>
                </template>
              </el-table-column>
              <el-table-column label="备注" prop="remark" align="center">
                <template v-slot:default="scope">
                  <el-input size="mini" v-if="formStatus" placeholder="备注" v-model="scope.row.remark"></el-input>
                  <span v-else>{{scope.row.remark}}</span>
                </template>
              </el-table-column>
              <el-table-column label="二维码" width="50" align="center">
                <template v-slot:default="scope">
                  <el-button type="primary" size="mini" icon="el-icon-view" circle @click.stop.prevent="showQR(scope.row.delivery_detail_id)"></el-button>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="50" align="center">
                <template v-slot:default="scope">
                  <el-button v-if="formStatus" type="danger" size="mini" icon="el-icon-minus" circle @click.stop.prevent="handlerDelDetails(scope.$index)"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="form-footer">
          <span>制单人：{{formData.creater_name}}</span>
          <span>制单日期：{{formData.create_time.substring(0,10)}}</span>
        </div>
      </el-form>
      <el-dialog
        :visible="isQRShow"
        :width="width"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
        :append-to-body="true"
        :show-close="false"
        @opened = "dialogOpen"
      >
        <div slot="title" class="dialog-title-container">
          <span class="title-label"><i class="el-icon-s-grid"></i>二维码</span>
          <i class="el-icon-error" @click="closeQR"></i>
        </div>
        <div ref="codeItem" style="margin-top:10px;display: flex;justify-content: center;margin-bottom: 10px;"></div>
      </el-dialog>
    </div>
  </el-dialog>
</template>
<style>
  .el-table .warning-row {
    background: #ffaa96;
  }
</style>
<script>
import QRCode from "qrcodejs2";
export default {
  name: 'EzzDialogForm',
  props: {
    parent: {
      type: Object,
      default: () => null
    }
  },
  data: function () {
    return {
      // 当前子组件对话框的显隐
      isShow: false,
      formData: null,
      formEmptyData: {
        id: '0',
        date: '',
        halfproduct_no: '',
        remark: '',
        details: [],
        creater_name: sessionStorage.getItem('operator'),
        creater_id: sessionStorage.getItem('operator_id'),
        create_time: ''
      },
      formDetailEmptyData: {
        id: '',
        halfproduct_id: '',
        delivery_id: '',
        delivery_detail_id: '',
        product_id: '',
        base_material_id: '',
        base_material_name: '',
        product_name: '',
        table_number: '',
        page: '',
        number: '0',
        position: '',
        position_value: '',
        remark: ''
      },
      positionArr: [],
      operator_id: sessionStorage.getItem('operator_id'),
      formStatus: false,
      inputdisabled: false,
      editable: this.$store.state.editable,
      delable: this.$store.state.delable,
      role_name: sessionStorage.getItem('role_name'),
      isQRShow: false,
      width: "40%",
      QRId:''
    }
  },
  beforeCreate: function () {
    var date = new Date()
    var month = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    var day = date.getDate() <= 9 ? '0' + date.getDate() : date.getDate()
    var hours = date.getHours() <= 9 ? '0' + date.getHours() : date.getHours()
    var mins = date.getMinutes() <= 9 ? '0' + date.getMinutes() : date.getMinutes()
    this.currentDate = date.getFullYear() + '-' + month + '-' + day
    this.currentTime = date.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + mins
  },
  created: function () {
    this.formData = JSON.parse(JSON.stringify(this.formEmptyData))
  },
  mounted: function () {
  },
  methods: {
    // 加载数据
    loadData: function () {
      let _this = this
      _this.post(_this.$apis.getHalfProsuctInstoreForm, { HalfProductInstoreId: _this.formData.id }, function (res) {
        let _json = res.data
        if (_json.status && _json.status === 'logout') {
          _this.logout()
        } else {
          _this.positionArr = _json.position
          if (_json.formData != null) {
            _this.formData = _json.formData
            for (let i = 0; i < _this.formData.details.length; i++) {
              if (_this.formData.details[i].position === '0') {
                _this.formData.details[i].position = ''
              }
            }
          } else {
            _this.formData = JSON.parse(JSON.stringify(_this.formEmptyData))
            _this.formData.creater_id = _this.operator_id
            _this.formData.create_time = _this.currentDate
            _this.formData.date = _this.currentTime
            _this.$nextTick(function () {
              _this.$refs.input.focus()
            })
          }
        }
      })
    },
    close: function () {
      this.$confirm('确定关闭？', '提示', {})
        .then(_ => {
          this.isShow = false
        })
        .catch(_ => {
          return false
        })
    },
    closeQR: function () {
      this.$confirm('确定关闭？', '提示', {})
        .then(_ => {
          this.isQRShow = false
        })
        .catch(_ => {
          return false
        })
    },
    dialogOpen: function(id){
      this.$refs.codeItem.innerHTML = "";
      new QRCode(this.$refs.codeItem, {
        // 二维码内容
        text:this.QRId,
        width: 300,
        height: 300, // 二维码颜色
        colorDark: "#333333", // 二维码背景色
        colorLight: "#ffffff"
      });
    },
    showQR : function(id){
      this.isQRShow = true
      this.QRId = id
    },
    // 行颜色变化（入库数量和送货数量不等）
    tableRowClassName ({ row, rowIndex }) {
      if (row.number !== row.delivery_number) {
        return 'warning-row'
      } else {
        return 'list-row'
      }
    },
    // 入库数量变化
    numberChange: function (_row) {
      if (_row.number === _row.delivery_number) {
        _row.exception_result = ''
      }
    },
    // 区域改变事件
    areaChange: function (value) {
      let _this = this
      _this.inputdisabled = true
      let count = 0
      count = _this.formData.details.filter(l => l.delivery_detail_id === value).length
      if (_this.$router.currentRoute.path === '/halfproductinstore/list' && value !== '') {
        // 同一表单下不能重复录入
        if (count !== 0) {
          _this.$message({
            type: 'error',
            message: '当前送货明细已存在'
          })
          _this.inputdisabled = false
        } else {
          _this.post(_this.$apis.getDeliveryStoreDetail, { DeliveryDetailId: value }, function (res) {
            let _json = res.data
            if (_json.status && _json.status === 'logout') {
              _this.logout()
            } else {
              // 不同表单下 不能重复录入
              if (_json.detail === null) {
                _this.$message({
                  type: 'warning',
                  message: '当前送货明细已入库'
                })
              } else {
                _this.formData.details.push(_json.detail)
              }
            }
            _this.inputdisabled = false
            _this.$nextTick(function () {
              _this.$refs.input.focus()
            })
          })
        }
        _this.formData.area = ''
      }
    },
    // 库位改变事件
    positionChange: function (item) {
      let resultArr = this.positionArr.filter((l) => { return l.id === item.position })
      item.position_value = resultArr[0].name
    },
    addHandler: function () {
      this.formData.id = '0'
      this.loadData()
      this.isShow = true
      this.formStatus = true
    },
    viewHandler: function (formId) {
      this.formData.id = formId
      this.loadData()
      this.isShow = true
      this.formStatus = false
    },
    handlerDelDetails: function (_index) {
      const _this = this
      _this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$delete(_this.formData.details, _index)
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 表单验证，_mainData是主表数据，_detailData从表数据，如果只验证从表数据，_mainData要设置为null
    validationHandler: function (_mainData) {
      let _this = this
      if (_mainData !== null) {
        if (_mainData.date === '') {
          _this.$message({
            type: 'error',
            message: '入库日期不能为空'
          })
          return false
        }

        if (_mainData.details.length === 0) {
          _this.$message({
            type: 'error',
            message: '入库明细不能为空'
          })
          return false
        }
        let bol = false
        for (var i = 0; i < _mainData.details.length; i++) {
          if (_mainData.details[i].delivery_number !== _mainData.details[i].number && _mainData.details[i].exception_result === '') {
            bol = true
          }
        }
        if (bol) {
          _this.$message({
            type: 'error',
            message: '送货数量和入库数量不相等，请填写异常原因'
          })
          return false
        }
      }
      return true
    },
    // 新增时主从表同时保存
    handerSave: function () {
      let _this = this
      if (_this.validationHandler(_this.formData)) {
        _this.formData.operator_id = _this.operator_id
        _this.post(_this.$apis.saveHalfProductInstore, _this.formData, function (res) {
          let _json = res.data
          if (_json.status && _json.status === 'logout') {
            _this.logout()
          } else {
            if (_json.status === 'ok') {
              _this.$message({
                message: '保存成功',
                type: 'success'
              })
              _this.resetSetItem('new_delivery_count', _json.delivery_count)
              _this.viewHandler(_json.id)
              _this.parent.loadData()
            }
            else if(_json.status === 'warning'){
              _this.$message({
                    type: "warning",
                    message: "无法保存：入库明细中数据部分或者全部已经出库!"
                  });
            }
          }
        })
      }
    }
  },
  components: {
  }
}
</script>
